import type { InformationSourceDto, InformationSourceInputDto, PagedRequestInformationSourceDto } from './models';
import { RestService, Rest } from '@abp/ng.core';
import { Injectable } from '@angular/core';
import type { PagedResultDto } from '../pagination/models';

@Injectable({
  providedIn: 'root',
})
export class InformationSourceService {
  apiName = 'Default';
  

  createInformationSourceByInput = (input: InformationSourceInputDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'POST',
      url: '/api/app/information-source/information-source',
      body: input,
    },
    { apiName: this.apiName,...config });
  

  deleteInformationSourceByInformationSourceId = (informationSourceId: number, config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'DELETE',
      url: `/api/app/information-source/information-source/${informationSourceId}`,
    },
    { apiName: this.apiName,...config });
  

  editInformationSourceByInputDto = (inputDto: InformationSourceInputDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'POST',
      url: '/api/app/information-source/edit-information-source',
      body: inputDto,
    },
    { apiName: this.apiName,...config });
  

  getAllInformationSourcesByInput = (input: PagedRequestInformationSourceDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, PagedResultDto<InformationSourceDto>>({
      method: 'GET',
      url: '/api/app/information-source/information-sources',
      params: { name: input.name, state: input.state, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName,...config });
  

  getInformationSourceByInformationSourceId = (informationSourceId: number, config?: Partial<Rest.Config>) =>
    this.restService.request<any, InformationSourceDto>({
      method: 'GET',
      url: `/api/app/information-source/information-source/${informationSourceId}`,
    },
    { apiName: this.apiName,...config });

  constructor(private restService: RestService) {}
}
